<template>
	<div>
		<v-layout class="banner">
			<div class="banner-img"></div>
		</v-layout>
		<div class="riiqosxn riiqosxn-intro">
			<v-container class="content">
				<v-row>
					<v-col col="12" sm="12" md="6">
						<h1 class="title-lg">Request A Demo</h1>
						<form class="form-contact" v-on:submit.prevent="submitContact">
							<div class="form-group form-row">
								<div class="col">
									<input type="text" v-model="formObj.fname" placeholder="George" required>
									<label>First Name</label>
								</div>
								<div class="col">
									<input type="text" v-model="formObj.lname" placeholder="Smith" required>
									<label>Last Name</label>
								</div>
								<div class="col">
									<input type="text" v-model="formObj.title" placeholder="Sales Manager" required>
									<label>Title</label>
								</div>
							</div>
							<div class="form-group form-row">
								<div class="col-4">
									<input type="text" v-model="formObj.company" placeholder="Company">
									<label>Company</label>
								</div>
								<div class="col-8">
									<input type="text" v-model="formObj.email" class="input-full" placeholder="george.smith@company.com" required>
									<label>Email</label>
								</div>
							</div>
							<div class="form-group form-row last-grp">
								<div class="col-4">
									<input type="text" v-model="formObj.phone" placeholder="(123) 456-7890" required>
									<label>Phone Number</label>
								</div>
								<div class="col-8">
									<vue-recaptcha sitekey="6LdtmtYUAAAAANks-Qxs1ukBKMwqQZQfYPJOMKZo" :loadRecaptchaScript="true"></vue-recaptcha>
								</div>
							</div>
							<div class="form-group form-row last-grp">
								<div class="col">
									<button class="btn" :disabled="formSubmit">Contact</button>
								</div>
							</div>
							<div class="form-group form-row response" v-show="notification">
								<div class="col"><span class="_checkcircle"></span> {{ notification }}</div>
							</div>
						</form>
					</v-col>
					<v-col col="12" sm="12" md="6">
						
					</v-col>
				</v-row>
			</v-container>
		</div>
	</div>
</template>

<script>
import { bus } from '../../main';
import VueRecaptcha from 'vue-recaptcha';

const axios = require('axios');

export default {
	name: 'demo',
	components: { VueRecaptcha },
	data: () => ({
		baseUrl: '',
		formObj: {
			fname: "",
			lname: "",
			title: "",
			company: "",
			email: "",
			phone: "",
			subject: "Request A Demo",
			form: "demo"
		},
		notification: '',
		formSubmit: false
	}),
	methods: {
		async recaptcha() {
			await this.$recaptchaLoaded();
			const token = await this.$recaptcha('login');
			console.log(token);
		},
		submitContact() {
			var dataString = new FormData();

			this.formSubmit = true;

			dataString.append('fname', this.formObj.fname);
			dataString.append('lname', this.formObj.lname);
			dataString.append('title', this.formObj.title);
			dataString.append('company', this.formObj.company);
			dataString.append('email', this.formObj.email);
			dataString.append('phone', this.formObj.phone);
			dataString.append('subject', this.formObj.subject);
			dataString.append('form', this.formObj.form);

      axios({
        method: 'post',
        url: `${this.baseUrl}/api/mail/send`,
        data: dataString
      })
      .then(response => {
				console.log(response);
				this.notification = response.data.mail;
				setTimeout( () => {
					this.notification = null;
					this.formObj.fname = null;
					this.formObj.lname = null;
					this.formObj.title = null;
					this.formObj.company = null;
					this.formObj.email = null;
					this.formObj.phone = null;
					this.formSubmit = false;
				}, 5000);
      })
      .catch(err => {
        console.log(err);
      });
		}
	},
	mounted () {
		this.baseUrl = 'https://test.riiqo.com';
		bus.$emit('update-route', this.$route);
	}
};
</script>
